import React from 'react';
import styled from 'styled-components';
import { useIntl, defineMessages } from 'react-intl';

import { Avatar, Button, Text } from '@companycam/slab-web';
import { AssignedUserObject } from 'data/v3/data-contracts';
import { useCurrentUser } from 'javascripts/hooks';

// #region styled-components
const Item = styled.li`
  display: flex;
  align-items: center;
  gap: var(--cc_size_spacing_m);
  margin-top: var(--cc_size_spacing_m);
`;
const AvatarContainer = styled.div`
  flex: 1;
  min-width: 1px;
  display: flex;
  align-items: center;
  gap: var(--cc_size_spacing_s);
`;
// #endregion

const messages = defineMessages({
  unassignButtonLabel: {
    id: 'AssignUsers.unassignButtonLabel',
    defaultMessage: 'Unassign',
    description: 'Button label for unassign button',
  },
});

type AssignedUserItemProps = {
  assignedUser: AssignedUserObject;
  onRemoveUser: (id: AssignedUserObject['id']) => void;
};

const AssignedUserItem = ({
  assignedUser,
  onRemoveUser,
}: AssignedUserItemProps) => {
  const { formatMessage } = useIntl();

  const currentUser = useCurrentUser();

  return (
    <Item>
      <AvatarContainer>
        <Avatar
          key={assignedUser.id}
          fullName={assignedUser.fullName}
          initials={assignedUser.initials}
          borderColor={
            assignedUser.id === currentUser.id
              ? 'var(--cc_color_utility_assigned)'
              : ''
          }
          size="small"
        />
        <Text
          as="span"
          size="s"
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {assignedUser.fullName}
        </Text>
      </AvatarContainer>
      <Button
        size="small"
        loading={false}
        disabled={false}
        onClick={() => onRemoveUser(assignedUser.id)}
      >
        {formatMessage(messages.unassignButtonLabel)}
      </Button>
    </Item>
  );
};

export default AssignedUserItem;
